import React, { useEffect, useRef, useState } from 'react';
import { Col, InputGroup, Form, Button, DropdownButton, ButtonGroup, Dropdown } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import HighlightOff from 'mdi-react/HighlightOffIcon';
import Search from 'mdi-react/SearchIcon';
import AddCircle from 'mdi-react/AddCircleIcon';

import { useModal } from 'modules/shared/hooks';
import { defaultGridState } from 'modules/common/constants';
import { GetTripColumnsNames, MIN_FILTER_VALUE_LENGTH } from 'modules/security/containers/TripsTabContainer/constants';
import { LogicTypes, FilterOperators, DataGrid, DataGridColumn } from 'modules/shared/DataGrid';
import { useGridState } from 'modules/shared/DataGrid/hooks/useGridState';
import { Filter, GridFilter } from 'modules/shared/DataGrid/utils/interfaces';
import AddToBlackList from 'modules/shared/AddToBlackList';
import { RootState } from 'rootReducer';
import { RolesReportTypes, SecurityReportProps } from '../interfaces';
import classes from './ReportSpecialList.module.scss';
import styles from '../../containers/TripsTabContainer/TripsTab.module.scss';
import { getBlackListRequest } from './actions';
import { RoleCell } from './RoleCell';

export const ReportSpecialList: React.FC<SecurityReportProps> = () => {
  const [filterInputValue, setFilterInputValue] = useState('');
  const dispatch = useDispatch();
  const [roleType, setRoleType] = useState<RolesReportTypes>();
  const [data, setData] = useState<any>();
  // const [modalData, setModalData] = useState<any>();
  const filterInputRef = useRef<HTMLInputElement>(null);
  const { isShow: isShowBLModal, openModal: openModalBLModal, closeModal: closeModalBLModal } = useModal();
  // const { isShow: isShowEditBLModal, openModal: openEditModalBLModal, closeModal: closeEditModalBLModal } = useModal();

  useEffect(() => {
    dispatch(getBlackListRequest());
  }, []);

  const reports = useSelector(
    (state: RootState) => state.securityModuleReducer.reportsReducer.BlackListReducer.reports,
  );

  useEffect(() => {
    let filtered;
    if (roleType === 'Відвідувач') {
      filtered = reports.filter((report: any) => report.role === 0 || report.role === 1);
      setData(filtered);
    }
    if (roleType === 'Транспорт') {
      filtered = reports.filter((report: any) => report.role === 2 || report.role === 3);
      setData(filtered);
    }
    if (roleType === 'Всі') {
      filtered = reports;
      setData(filtered);
    }
  }, [roleType]);

  const gridState = useGridState(data, defaultGridState);

  useEffect(() => {
    if (filterInputValue.length < MIN_FILTER_VALUE_LENGTH) {
      gridState.setFilter({
        logic: LogicTypes.and,
        filters: [],
      });
    } else {
      const fieldsNames = Object.keys(GetTripColumnsNames(true));
      const newFilter = {
        logic: LogicTypes.or,
        filters: fieldsNames.map(
          (name): Filter => ({
            operator: FilterOperators.contains,
            value: filterInputValue,
            field: name,
          }),
        ),
      } as GridFilter;
      gridState.setFilter(newFilter);
    }
  }, [filterInputValue]);

  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilterInputValue(e.target.value);
  };

  const handleClearIconClick = () => {
    setFilterInputValue('');
    if (filterInputRef.current) {
      filterInputRef.current.focus();
    }
  };

  const handleSelect = (eventKey: any) => {
    setRoleType(eventKey);
  };

  // const onRow = (rowData: DefaultRecordType) => ({
  //   onDoubleClick: () => {
  //     setModalData(rowData);
  //     return openEditModalBLModal();
  //   },
  // });

  return (
    <React.Fragment>
      <div className="pb-3 mx-0 px-0">
        <Button variant="light" className={classes.add} onClick={() => openModalBLModal()}>
          &nbsp;
          <AddCircle className={styles.plusIcon} /> Додати&nbsp;
        </Button>
        <div className="d-flex align-items-center ml-2">
          <span className="mr-2">Роль: </span>
          <DropdownButton
            variant="outline-secondary"
            title={roleType || 'Оберіть роль'}
            as={ButtonGroup}
            className={classes.btn_role}
          >
            {Object.entries(RolesReportTypes).map(([key, value]: [string, string]) => (
              <Dropdown.Item key={key} eventKey={value} onSelect={handleSelect}>
                {value}
              </Dropdown.Item>
            ))}
          </DropdownButton>
        </div>
        <Col className="d-flex flex-row align-items-center justify-content-end pr-0">
          <div className="d-flex align-items-center justify-content-end col pr-0">
            <InputGroup className={classes.filter}>
              <Form.Control
                as="input"
                type="text"
                name="filter"
                onChange={handleFilterChange}
                value={filterInputValue}
                ref={filterInputRef}
              />
              <Search size={18} className={classes.searchIcon} />
              {!!filterInputValue && (
                <HighlightOff size={18} className={classes.clearFilterIcon} onClick={handleClearIconClick} />
              )}
            </InputGroup>
          </div>
        </Col>
      </div>
      <DataGrid
        pageable
        data={gridState.gridData}
        sort={gridState.sort}
        total={gridState.total}
        skip={gridState.pagination?.skip}
        pageSize={gridState.pagination?.pageSize}
        onPageChange={gridState.handlePageChange}
        onSortChange={gridState.handleSortChange}
        // onRow={onRow}
      >
        <DataGridColumn title="ПІБ/Назва" dataIndex="description" key="description" width="10%" />
        <DataGridColumn title="Роль" dataIndex="role" key="role" width="10%" render={RoleCell} />
        <DataGridColumn title="Номер" dataIndex="number" key="number" width="5%" />
        <DataGridColumn title="Коментар" dataIndex="comment" key="comment" width="10%" />
      </DataGrid>

      <AddToBlackList show={isShowBLModal} closeHandler={closeModalBLModal} />
      {/* <EditBlackListModal show={isShowEditBLModal} modalData={modalData} closeHandler={closeEditModalBLModal} /> */}
    </React.Fragment>
  );
};
